const dev = {
    serverConfig: {
        "jupiter-service": {
            protocol: "http",
            host: "localhost:8091",
        },
        "data-service": {
            protocol: "http",
            host: "localhost:8090",
        }
    },
    "cacheForm": false
};

const prod = {
    serverConfig: {
        "jupiter-service": {
            "protocol": "https",
            "host": "stockhelper.duckdns.org"
        },
        "data-service": {
            "protocol": "https",
            "host": "dataservicehelper.duckdns.org"
        }
    },
    "cacheForm": true
};


const appEnv = process.env.REACT_APP_ENV || process.env.NODE_ENV || "development";

const config = appEnv === "development" ? dev : prod;
// const config = prod;

const appConfig = {
    // Add common config values here
    MAX_ATTACHMENT_SIZE: 5000000,
    ...config,
};

export default appConfig;
